export default {
  getScriptGroup: state => state.scriptGroup,
  getScriptGroups: state => state.scriptGroups,
}
